import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#dd3535',
          secondary: '#18206F',
          accent: '#6C8EAD',
          warning: '#F4D58D',
          error: '#dd3535',
        },
        dark: {
          primary: '#dd3535',
          secondary: '#2196f3',
          accent: '#6C8EAD',
          warning: '#F4D58D',
          error: '#dd3535',
        },
      },
    },
  });
